import { ROUTE_HOME } from "@/constants/routes.constants";
import { useMediaQuery } from "@/hooks/mediaQuery";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import { AgentModel } from "@/types";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

type SidebarModelButtonProps = {
  model: AgentModel;
  hideSidebar: () => void;
};

const SidebarModelButton: React.FC<SidebarModelButtonProps> = ({
  model,
  hideSidebar,
}) => {
  const { setSelectedAgentModel, agentsModels, selectedAgentModel } =
    useContext(AppContext);
  const nav = useNavigate();
  const isNotSmall = useMediaQuery("sm");

  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  // Check if text is overflowing
  const checkOverflow = () => {
    if (textRef.current) {
      const isTextOverflowing =
        textRef.current.scrollWidth > textRef.current.clientWidth;
      setIsOverflowing(isTextOverflowing);
    }
  };

  // Initial check
  useEffect(() => {
    checkOverflow();
  }, [model.name]);

  return (
    <Button
      key={model.id}
      variant={undefined}
      className={`flex w-full items-center justify-start gap-2 overflow-hidden bg-transparent text-left text-white transition-all hover:bg-transparent hover:text-shadow-2xs hover:text-shadow-[#ffffff8a] ${selectedAgentModel?.id === model.id ? "bg-gray-700 hover:bg-gray-700" : ""} `}
      onMouseEnter={checkOverflow}
      onClick={() => {
        setSelectedAgentModel(model);
        nav(ROUTE_HOME);
        if (!isNotSmall) {
          hideSidebar();
        }
      }}
    >
      <div className="relative w-full">
        <div
          ref={textRef}
          className={`truncate select-none ${isOverflowing ? "hover:animate-slide-horizontal hover:w-max" : ""}`}
        >
          {model.name}
        </div>
      </div>
    </Button>
  );
};

export default SidebarModelButton;
